<template>
    <div class="page_container">
        <div class="page_header">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>用户列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-card class="page_card" v-loading="loading">
          <el-form class="search_form" size="small" @submit.native.prevent :inline="true">
            <el-form-item label="关键词">
              <el-input
                class="keyword_input"
                v-model.trim="searchForm.keyWords"
                placeholder="请输入用户姓名、手机号、邮箱"
                @clear="handleClickSearch"
                @keyup.enter.native="handleClickSearch"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item class="search_actions">
              <el-button type="primary" icon="el-icon-search" @click="handleClickSearch">搜索</el-button>
              <el-button icon="el-icon-refresh" @click="handleClickReset">重置</el-button>
            </el-form-item>
          </el-form>

          <template>
            <el-table ref="table1" :data="tableData" style="width: 100%" :height="tableHeight">
              <el-table-column prop="uid" align="center" label="序号" width="80"></el-table-column>

              <el-table-column prop="nameS" align="center" label="姓名" min-width="120">
                <template slot-scope="{row}">
                   <span class="template_color" @click="handleClickUserDetail(row)">{{row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="nameS" align="center" label="头像" width="80">
                <template slot-scope="{row}">
                  <img v-if="row.avatar" :src="row.avatar" style="width: 28px;height: 28px;border-radius: 50%;display: block;margin: 0 auto" alt="">
                </template>
              </el-table-column>
              <el-table-column prop="phone" align="center" label="手机号" min-width="160"></el-table-column>
              <el-table-column prop="email" align="center" label="邮箱" min-width="120"></el-table-column>
<!--              <el-table-column prop="date" align="center" label="注册时间" min-width="120"></el-table-column>-->
              <el-table-column prop="last_login_time" align="center" label="上次登录时间" width="140">
                <template slot-scope="{row}">
                  <span v-if="row.last_login_time" v-text="convertToCurrentTimezone(row.last_login_time,'/','datetime')"></span>
                </template>
              </el-table-column>
            </el-table>
          </template>


          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="pagination.pageNum"
                         :page-sizes="pagination.pageSizes"
                         :page-size="pagination.pageSize"
                         :layout="pagination.layout"
                         :total="pagination.total">
          </el-pagination>


        </el-card>
    </div>
</template>

<script>
import {adminUserList } from '@/api/api'
import {getTableHeight,convertToCurrentTimezone} from '@/utils'
import {pagination} from '@/mixins'
import {mapState} from "vuex";

export default {
    name: 'individual_users',

    data() {
        return {
          loading:false,
          tableData:[ ],
          tableHeight:'',
          searchForm:{
            keyWords:''
          }
        }
    },

    mixins: [pagination],
    created() {
      //将计算的table高度赋值给table
      this.tableHeight = getTableHeight(265)
    },
    mounted() {
      this.getTableData()
      //窗口缩放时动态修改table的高度
      window.onresize = () => {
        if (this.resizeTimer) {
          clearTimeout(this.resizeTimer)
        }
        //开启定时器，节流函数
        this.resizeTimer = setTimeout(() => {
          //将计算的table高度赋值给table
          this.tableHeight = getTableHeight(265)
          //清除定时器
          this.resizeTimer = null
        }, 100)
      }
    },
    computed: {
      ...mapState(['adminUserInfo']),
    },
    methods: {
      convertToCurrentTimezone(utcTime,separator,type) {
        return convertToCurrentTimezone(utcTime,separator,type);
      },
      handleClickUserDetail(row){
        this.$router.push({name:'user_detail',query:{uid:row.uid,company_id:row.company_id}});
      },

      getTableData() {
        this.loading = true
        let postData = {
          page: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          keyword:this.searchForm.keyWords
        }
        adminUserList(postData).then(res => {
          if (res.code === 200) {
            let {total, data} = res.data
            this.tableData = data
            this.pagination.total = total
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.pagination.pageNum = 1
        this.pagination.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        this.pagination.pageNum = val
        this.getTableData()
      },
      // 搜索
      handleClickSearch(){
        this.pagination.pageNum = 1
        this.getTableData()
      },
      // 重置
      handleClickReset(){
        this.searchForm.keyWords = ''
        this.pagination.pageNum = 1
        this.getTableData()
      },

    },
    watch: {

    },
}
</script>

<style scoped lang="scss">
.search_form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 8px;
}
.keyword_input {
  width: 300px;
}
.search_actions {
  white-space: nowrap;
}
.kx {
    width: 100%;
    height: 30px;
}
.chart{
    height:540px
}
.page_container .page_card {
    overflow-y: scroll;
    padding-bottom: 20px;
}

.filed_list{
  color: #000;
  line-height: 24px;
  font-size: 16px;
  margin-bottom: 12px;
}
</style>
